import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { ButtonMedium, media } from 'app/assets/styles'
import { colors as oldColors } from 'shared/assets/styles'
import { colors } from 'app-v2/design-systems/theme'
import { styleCaptionText, styleSmallText, Text } from 'app/common/typography'
import { Collapse } from 'react-collapse'
import { Question } from 'app/assets/icons'
import { Error, Input } from 'app/common/forms'

type Props = {
    cardUpdateError?: ?string,
    cardUpdateSuccess?: boolean,
    error?: boolean,
    errorKey: string,
    isSubmitting: boolean,
    submitButtonTextKey?: string,
    name: string,
    labelKey: string,
    placeholderKey: string,
    className?: string
}

type State = {
    collapsed: boolean
}

const { yellow, red } = oldColors

export class LoyaltyCardForm extends Component<Props, State> {
    constructor() {
        super()
        this.state = {
            collapsed: true
        }
    }

    collapseBlock = () => {
        this.setState({ collapsed: !this.state.collapsed })
    }

    render() {
        const {
            cardUpdateError,
            cardUpdateSuccess,
            error,
            isSubmitting,
            submitButtonTextKey,
            labelKey,
            name,
            placeholderKey,
            errorKey,
            className = ''
        } = this.props
        const { collapsed } = this.state

        return (
            <Fragment>
                <TextContainer
                    className={className}
                    onClick={this.collapseBlock}>
                    <FormattedMessage id="kingdom.card.alreadyHaveCard.title">
                        {(text: string) => (
                            <HeadText underline className={className}>
                                {text}
                            </HeadText>
                        )}
                    </FormattedMessage>
                    <Question background={yellow} />
                </TextContainer>
                <Collapse isOpened={!collapsed}>
                    <CollapseContainer>
                        <FormattedMessage id="kingdom.card.alreadyHaveCard.description">
                            {(text: string) => <StyledText>{text}</StyledText>}
                        </FormattedMessage>
                        <Input
                            name={name}
                            type="text"
                            labelKey={labelKey}
                            placeholderKey={placeholderKey}
                            className={error ? 'error' : ''}
                        />
                        {error && <Error errorKey={errorKey} />}
                        {submitButtonTextKey && (
                            <ButtonContainer>
                                <StyledButtonMedium
                                    type="submit"
                                    disabled={isSubmitting}
                                    background={yellow}>
                                    <FormattedMessage
                                        id={submitButtonTextKey}
                                    />
                                </StyledButtonMedium>
                            </ButtonContainer>
                        )}
                        {cardUpdateError && (
                            <Mentions>
                                <FormattedMessage id={cardUpdateError}>
                                    {(text: string) => (
                                        <Text color={red}>{text}</Text>
                                    )}
                                </FormattedMessage>
                            </Mentions>
                        )}
                        {cardUpdateSuccess && (
                            <Mentions>
                                <FormattedMessage id="kingdom.card.form.success">
                                    {(text: string) => (
                                        <Text color={colors.crunchyGreen}>
                                            {text}
                                        </Text>
                                    )}
                                </FormattedMessage>
                            </Mentions>
                        )}
                    </CollapseContainer>
                </Collapse>
            </Fragment>
        )
    }
}

const TextContainer = styled.div`
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    svg {
        margin-left: 3px;
    }

    &.signup {
        text-decoration: underline;
    }
`

const HeadText = styled(Text)`
    &.signup {
        ${styleCaptionText};
        color: ${oldColors.grey};
        ${media.xsmall`
            ${styleSmallText};
        `};
    }
`

const CollapseContainer = styled.div`
    padding: 25px;
    ${media.xsmall`
        padding: 30px;
    `};
`

const StyledText = styled(Text)`
    margin-bottom: 10px;
`

const Mentions = styled.div`
    margin-top: 25px;
`

const StyledButtonMedium = styled(ButtonMedium)`
    align-self: center;
    border: none;
`

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 0;
`
